import React, { Component } from "react";

class Form extends Component {
  state = {
    data: [],
    control: null,
    loaded: false,
  };

  constructor(props) {
    super(props);

    this.createTable = this.createTable.bind(this);
  }

  componentDidMount() {
    this.setState({
      control: this.props.control,
      loaded: true,
      data: this.props.data,
    });
  }

  createTable() {
    let output = [];
    this.state.data.forEach((itm, idx) => {
      output.push(
        <div>
          <div>{itm.mike.component}</div>
          <div>{itm.id.component}</div>
          <div>{itm.email.component}</div>
          <div>{itm.year.component}</div>
        </div>
      );
    });

    return <form>{output}</form>;
  }

  render() {
    if (this.state.loaded) {
      return this.createTable();
    } else {
      return "";
    }
  }
}

export default Form;
